export default "__VITE_ASSET__efd80378__"